import { type Cargo, type Descriptivo, etiquetaDeNivel } from "@/componentes/cargos/cargo"
import { FuncionesDelFlujo } from "@/componentes/cargos/FuncionesDelFlujo"

/** El mismo cargo, para quien lo consulta y no lo administra. */
export function LecturaDeCargo({
  cargo,
  descriptivo,
}: {
  cargo: Cargo
  descriptivo?: Descriptivo
}) {
  const apagado = { color: "var(--fg-muted)" }
  return (
    <div>
      <h2 className="rotulo mb-3">
        Descriptivo de «{cargo.nombre}»{cargo.activo ? "" : " (retirado)"}
      </h2>
      <dl className="mb-4 grid gap-3 text-sm sm:grid-cols-2">
        <div>
          <dt className="mb-1 text-xs font-medium uppercase" style={apagado}>
            Departamento
          </dt>
          <dd>{cargo.departamento_nombre ?? "Sin departamento"}</dd>
        </div>
        <div>
          <dt className="mb-1 text-xs font-medium uppercase" style={apagado}>
            Nivel en la estructura
          </dt>
          <dd>{etiquetaDeNivel(cargo.nivel)}</dd>
        </div>
        <div className="sm:col-span-2">
          <dt className="mb-1 text-xs font-medium uppercase" style={apagado}>
            Reporta a
          </dt>
          <dd>{cargo.reporta_a_nombre ?? "A nadie (dirección)"}</dd>
        </div>
      </dl>

      <h3 className="rotulo mb-2">Para qué existe el puesto</h3>
      <p className="mb-4 text-sm" style={cargo.descripcion ? undefined : apagado}>
        {cargo.descripcion ?? "Todavía no se ha escrito."}
      </p>

      <h3 className="rotulo mb-2">Funciones escritas a mano</h3>
      {cargo.funciones.length === 0 ? (
        <p className="text-sm" style={apagado}>
          Ninguna todavía.
        </p>
      ) : (
        <ol className="list-decimal space-y-1 pl-5 text-sm">
          {cargo.funciones.map((f, i) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: una funcion no tiene id
            <li key={`f-${i}`}>{f}</li>
          ))}
        </ol>
      )}

      <FuncionesDelFlujo descriptivo={descriptivo} />
    </div>
  )
}
